import React from 'react';

import { Route } from 'react-router-dom';
import styled, { ThemeProvider, css } from 'styled-components';

import { GlobalStyle } from '../styles/globalStyle';
import { theme } from '../styles/themes';

import Header from '../components/MainHeader';
import MainNavigation from '../components/MainNavigation';

const StyledLayout = styled.div`
  padding: 2rem;
  .body-wrapper {

  }
`

const Body = (props) => {
    return (
        <>
            {props.children}
        </>
    )
}

const Layout = ({ component: Component, ...rest }) => {
    document.title = rest.title;
    return (
        <Route {...rest} render={props => (
            <Body>
                <GlobalStyle />
                <div className="body-wrapper">  
                    <Component {...props} />
                </div>
            </Body>
        )} />
    )
}

export default Layout
